import React, { useEffect, useState } from 'react'
import Header from './component/bak/Header'
import MainPage from "./component/bak/MainPage"
import { Route, Routes } from 'react-router-dom'
import MemberRoute from './member/MemberRoute'
import { Box, Button, Grid } from '@mui/material'
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import ASVRoute from './asv/ASVRoute'
import Menubar from './component/bak/MenuPage'

const Main = () => {
  const [menuOpen, setMenuOpen] = useState(true);

  return (
    <Box>
      <Box>
        <Header />
      </Box>
      <Grid container sx={{ flexGrow: 1 }}>
        {/* <Box sx={{ border: "1px solid #e7ebf0" }} >
          {menuOpen ? <Box sx={{ zIndex: 900, padding: 1, fontSize: "xx-large", position: "absolute" }}>Menu<ArrowCircleLeftOutlinedIcon sx={{ marginLeft: "110px", fontSize: 40, color: "#000", cursor: 'pointer', ':hover': { color: '#4caf50' } }} onClick={() => setMenuOpen(!menuOpen)} /></Box> : <></>}
          {menuOpen ? <MenuPage /> : <></>}
        </Box> */}
        <Box sx={{ border: "1px solid #e7ebf0" }} >
          {menuOpen ? <Box sx={{ zIndex: 900, padding: 1, fontSize: "xx-large", position: "absolute" }}>Menu<ArrowCircleLeftOutlinedIcon sx={{ marginLeft: "110px", fontSize: 40, color: "#000", cursor: 'pointer', ':hover': { color: '#4caf50' } }} onClick={() => setMenuOpen(!menuOpen)} /></Box> : ""}
          {menuOpen ? <Menubar /> : ""}
        </Box>
       
        <Box width={menuOpen === true ? "176vh" : "100%"} marginLeft={menuOpen === true ? "254px" : "0px"} height="calc(100vh - 54px)" position="absolute">
          {!menuOpen ? <Box sx={{ zIndex: 900, padding: 1 }} position="absolute"><ArrowCircleRightOutlinedIcon sx={{ fontSize: 40, color: "#000", cursor: 'pointer', ':hover': { color: '#4caf50' } }} onClick={() => setMenuOpen(!menuOpen)} /></Box> : ""}
          <Routes>
            {/* <Route path="main" element={<MainPage />} /> */}
            <Route path="member/*" element={<MemberRoute />} />
            <Route path="asv/*" element={<ASVRoute />} />
          </Routes>
        </Box>
      </Grid>
    </Box>
  );
};

export default Main;